<button
  mat-icon-button
  class="initials-icon"
  [disabled]="true"
  [style.background]="util.getAvatarGradient(nameInitials)"
  [class.small-initials-icon]="size === 'small'"
  [class.large-initials-icon]="size === 'large'">
  <div class="name-initials">
    @if (!isUnknownNumber) {
      <tidy-text
        [body]="nameInitials" />
    }
    @if (isUnknownNumber) {
      <tidy-image
        [src]="'assets/img/person-white.svg'"
        style="display: flex; align-items: center; justify-content: center; width: 20px; height: 20px; margin: auto;" />
    }
  </div>
</button>
